export { LoadTimeout, Environments } from '../app-config.constants';

export enum ToastrType {
  Success,
  Info,
  Error,
  Warning,
}

export enum Client {
  client_id = 'EmployeePortal',
  client_secret = 'EmployeePortalSecrets',
  grant_type = 'password',
  refresh_token = 'refresh_token',
}

export enum TokenRefresh {
  time = 50 * 60 * 1000,
}

export enum ValidatorPatterns {
  none = '',
  alphaNumeric = '^[ a-zA-Z0-9]*$',
  alphaNumericNoSpace = '^[a-zA-Z0-9]*$',
  alphaNumericNoSpacedash = '^[a-zA-Z0-9-]*$',
  alphaNumericDotApostrophe = "^[ A-Za-z0-9.']*$",
  numeric = '^[0-9]*$',
  alphaDotApostrophe = "^[ A-Za-z.']*$",
  alphaNumericDotApostropheSpaceHyphen = "^[ A-Za-z0-9.'-]*$",
  email = '^[A-Za-z0-9]([A-Za-z0-9_\\.-]*[A-Za-z0-9])?@[A-Za-z0-9_\\-]+(?:\\.[A-Za-z0-9_\\-]+)*\\.([A-Za-z]{2,4})$',
  url = '^[A-Za-z][A-Za-z\\d.+-]*:/*(?:\\w+(?::\\w+)?@)?[^\\s/]+(?::\\d+)?(?:/[\\w#!:.?+=&%@\\-/]*)?$',
  socialMediaRegex = '^(https?://)?(www.)?(facebook|linkedin|twitter|instagram).com/[a-zA-Z0-9_w#!:.?+=&%@\\-/]+/?$',
  noteDescription = '^[ a-zA-Z0-9`~!@#$%^&<>,./*-_=+\n(){}|\'"]*$',
  note = '^[^s(\r\n|\r|\n)].*$',
  alphabetsOnly = '^[a-zA-Z\b ]+$',
  // EN-29808 — ported from PEO's ConstantVariables.ts (used by Employee Onboarding's
  // Personal Information tab, emergency-contact relationship field).
  alphabeticPattern = '^[a-zA-Z]+$',
  alphanumericwithDotApostrophe = "^[ A-Za-z0-9.']*$",
  // percentage = '^((100(\\.0{1,2})?)|([1-9]\\d?(\\.\\d{1,2})?))%',
  rate = '^((?!0)\\d{1,3}|0|\\.\\d{1,4})($|\\.$|\\.\\d{1,4}$)',
  numericPattern = '^[0-9]{1,3}$',
  decimal8Or8_2 = "^[ 0-9.']*$",
  dashdecimal8Or8_2 = "^-?[ 0-9.']*$",
  numericPatternBenefits = '^[0-9.\b]+$',
  numericIncludingHyphen = '^[0-9-]*$',
  password = '^[/(?=.*d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/]',
  percentage = '^((?!0)\\d{1,3}|0|\\.\\d{1,2})($|\\.$|\\.\\d{1,2}$)',
  rates = '^((?!0)\\d{1,4}|0|\\.\\d{1,2})($|\\.$|\\.\\d{1,2}$)',
  amount = '^\\d+(\\.\\d{1,2})?\\.?$',
  withoutSpace = '[^ ]$',
  noSpaceAtStart = '^[A-Za-z0-9]+(?:.)*$',
  urlWebsite = '^(https?|ftp)://[A-Za-z0-9.-]+(?:.[A-Za-z]{2,})?(:d+)?(?:/[^s]*)?$',
}

export enum VisibilityStatus {
  public = 'public',
  private = 'private',
  confidential = 'confidential',
}

export enum BenefitTypes {
  benefitAllowance = 'Benefit Allowance',
  dental = 'Dental',
  vision = 'Vision',
  healthSavingAccount = 'Health Savings Account',
  eap = 'EAP',
  medical = 'Medical',
  medicalUnderwriting = 'Medical Underwriting',
  medicalSupplemental = 'Medical Supplemental',
  gapMedical = 'Gap Medical',
  medicalLimited = 'Medical Limited',
  voluntaryDental = 'Voluntary Dental',
  pediatricDental = 'Pediatric Dental',
  voluntaryVision = 'Voluntary Vision',
  discountProgram = 'Discount Program',
  healthReimbursementAccount = 'Health Reimbursement Account',
  individualCoverageHealthReimbursementAccount = 'Individual Coverage Health Reimbursement Account',
  healthSavingsAccount = 'Health Savings Account',
  vEBA = 'VEBA',
  criticalIllness = 'Critical Illness',
  prescriptionDrug = 'Prescription Drug',
  cancer = 'Cancer',
  cancerExpense = 'Cancer Expense',
  intensiveCare = 'Intensive Care',
  hospitalConfinement = 'Hospital Confinement',
  accident = 'Accident',
  chiropractic = 'Chiropractic',
  acupuncture = 'Acupuncture',
  simpleIRA = 'Simple IRA',
  shortTerm = 'Short Term',
  shortTermDisability = 'Short Term Disabilit',
  shortTermDisabilityBuyUp = 'Short Term Disability Buy-Up',
  longTermDisability = 'Long Term Disability',
  longTermDisabilityBuyUp = 'Long Term Disability Buy-Up',
  paidFamilyLeave = 'Paid Family Leav',
  lifeADandD = 'Life/AD&D',
  life = 'Life',
  aDandD = 'AD&D=',
  supplementalLife = 'Supplemental Life',
  hearing = 'Hearing',
  section125 = 'Section 125',
  fSAHealthCare = 'FSA Health Care',
  fSADependentCare = 'FSA Dependent Care',
  transit = 'Transit',
  parking = 'Parking',
  premiumReimbursementAccount = 'Premium Reimbursement Account',
  healthConcierge = 'Health Concierge',
  advocacy = 'Advocacy',
  voluntaryShortTermDisability = 'Voluntary Short Term Disability',
  voluntaryLifeADandD = 'Voluntary Life/AD&D',
  voluntaryLife = 'Voluntary Life',
  voluntaryADandD = 'Voluntary AD&D',
  voluntaryCriticalIllness = 'Voluntary Critical Illness',
  voluntaryAccident = 'Voluntary Accident',
  voluntaryCancer = 'Voluntary Cancer',
  voluntaryHospitalConfinement = 'Voluntary Hospital Confinement',
  voluntaryTermLife = 'Voluntary Term Life',
  universalLife = 'Universal Life',
  voluntaryLongTermCare = 'Voluntary Long Term Care',
  longTermCare = 'Long Term Care',
  legal = 'Legal',
  identityTheft = 'Identity Theft',
  four01k = '401k',
  roth401k = 'Roth 401k',
  retirement = 'Retirement',
  cost = 'Cost',
  fitness = 'Fitness',
  phone = 'Phone',
  benefit1 = 'Benefit 1',
  benefit2 = 'Benefit 2',
  five29 = '529',
  vacationBuyBack = 'Vacation Buy Back',
  telemedicine = 'Telemedicine',
  teladoc = 'Teladoc',
  wholeLife = 'Whole Life',
  termLife = 'Term Life',
  specifiedDisease = 'Specified Disease',
  pet = 'Pet',
  four03b = '403b',
  travelAssistance = 'Travel Assistance',
  perks = 'Perks',
  financialWellBeing = 'Financial Well-Being',
  voluntaryLongTermDisability = 'Voluntary Long-Term Disability',
  wellness = 'Wellness',
}

export enum SortDirection {
  asc,
  desc,
}

export enum MaxLimits {
  maxFileUploadSize = 5242880, // 5 MB = 5 * 1024 * 1024 (in KB)
  maxFileUploadSize10 = 10485760, // 10 MB = 10 * 1024 * 1024 (in KB)
}

export enum Role {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Staffer = 'Staffer',
  Guest = 'Guest',
}

export enum AlterColumnTaskTableType {
  taskName = 'taskName',
}

export enum JobRequestStatusEnum {
  InReview = 'In Review',
  RequireMoreDetail = 'Require More Detail',
  Onhold = 'On hold',
  Approved = 'Approved',
  Canceled = 'Cancelled',
}

export enum AppId {
  isEnwage = 5,
}

export enum DeductionCodeTypes {
  Maximum = 'Maximum',
  Limit = 'Limit',
}

export enum PtoRequestStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Denied = 'Denied',
}

export enum TimesheetType {
  Staffing = 'Staffing',
  Payroll = 'Payroll',
}

export enum Category {
  ChildSupport = 'Child Support',
  SpousalSupport = 'Spousal Support',
  IRSTaxLevy = 'IRS Tax Levy',
  BankruptcyOrder = 'Bankruptcy Order',
  StateTaxLevy = 'State Tax Levy',
  FranchiseTaxBoard = 'Franchise Tax Board',
  CreditorWageGarnishment = 'Creditor Wage Garnishment',
  StudentLoan = 'Student Loan',
}

export enum PayFrequencyOptions {
  Weekly = 'Weekly',
  Biweekly = 'Bi-Weekly',
  SemiMonthly = 'Semi-Monthly',
  Monthly = 'Monthly',
}

export enum KurenseStatus {
  RequestPayCard = 1,
  PayCardRequested = 2,
  PayCardIssued = 3,
}

// EN-29808 — ported from PEO for the Employee Onboarding state tax forms (maskTaxType).
export enum TaxTypeEnum {
  FEIN = 'fein',
  SSN = 'ssn',
  ITIN = 'itin',
}

export enum EmployeeDepositStatusEnum {
  Prenote = 'Pre-notify',
  DirectDepositActive = 'Direct Deposit Active',
  DirectDepositInactive = 'Direct Deposit Inactive',
}
